module.exports = __webpack_public_path__ + "img/806a3cca78ba57c52fa5446b4d8eb7fa.png";